import React from 'react';
import ReactDOM from 'react-dom';
import {Provider as RollbarProvider, ErrorBoundary} from '@rollbar/react';
import './index.less';
import App from './App';
import { PlatformProvider } from './context/PlatformContext';
import ErrorFallback from './components/ErrorFallback';
import {rollbar} from './services/rollbar';

// Outermost on purpose: PlatformProvider and ProvideAuth both block rendering on a
// network call, and a throw in either would otherwise leave a blank page with nothing
// reported. Uncaught errors and rejections are captured by the notifier itself.
ReactDOM.render(
  <React.StrictMode>
    <RollbarProvider instance={rollbar}>
      <ErrorBoundary fallbackUI={ErrorFallback}>
        <PlatformProvider>
          <App />
        </PlatformProvider>
      </ErrorBoundary>
    </RollbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
